import { Button } from '@pwc/pwc-deals-ui';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getEditMode,
  setEditMode,
} from '../../../../features/divestitureDiagnostic/divestitureDiagnosticSlice';

import './ResultsHeader.scss';

const ResultsHeader = ({
  saveDisabled,
  editDisabled,
  cancelDisabled,
  onSave,
}) => {
  const dispatch = useDispatch();
  const isEditMode = useSelector(getEditMode);

  return (
    <div className="results-header-wrapper">
      {!isEditMode && (
        <Button
          className="results-edit-button button-small"
          onClick={() => dispatch(setEditMode(true))}
          disabled={editDisabled}
        >
          Edit
        </Button>
      )}
      {isEditMode && (
        <>
          <Button
            className="results-cancel-button button-link"
            onClick={() => dispatch(setEditMode(false))}
            disabled={cancelDisabled}
          >
            Cancel
          </Button>
          <Button
            className="results-save-button button-small"
            onClick={onSave}
            disabled={saveDisabled}
          >
            Save
          </Button>
        </>
      )}
    </div>
  );
};

export default ResultsHeader;
